import React from 'react';
import Button from './Button';

const RadioCustom = ({options, changeType, checked}) => {
    const style1 = "border-y border-[#0987F3] bg-[#0987F3] text-white text-sm font-semibold w-[180px] laptop-Merchant:w-[180px]  tablet-Merchant:min-w-[150px] tablet-Merchant:max-w-[25%] mobile-Merchant:w-[160px] h-10 laptop:h-14 laptop:px-4 mobile:h-14 mobile:px-4 text-wrap hover:opacity-90 duration-150";
    const style2 = "border-y border-slate-300 text-slate-500 text-sm font-semibold w-[180px] laptop-Merchant:w-[180px]  tablet-Merchant:min-w-[150px] tablet-Merchant:max-w-[25%] tablet-Merchant:w-auto mobile-Merchant:w-[160px] h-10 laptop:h-14 laptop:px-4 mobile:h-14 mobile:px-4 text-wrap hover:text-[#0987F3] duration-150";
    return (
        <>
            <div className='flex mobile-Merchant:hidden tablet-Merchant:justify-center'>
                {options.map((e, index) => {
                    if (index === 0) {
                        return (
                            <Button key={"radio_" + index}
                                    style={checked === e.value ? `border-l rounded ${style1}` : `border-l rounded-s-lg ${style2}`}
                                    name={e.label} onclick={() => changeType(e.value)}/>
                        );
                    }
                    if (index === options.length - 1) {
                        return (
                            <Button key={"radio_" + index}
                                    style={checked === e.value ? `border-x rounded-e-lg ${style1}` : `border-x rounded-e-lg ${style2}`}
                                    name={e.label} onclick={() => changeType(e.value)}/>
                        );
                    }
                    return (
                        <Button key={"radio_" + index}
                                style={checked === e.value ? `border-l ${style1}` : `border-l ${style2}`} name={e.label}
                                onclick={() => changeType(e.value)}/>
                    );
                })}
            </div>
            <div className="flex-col hidden mobile-Merchant:flex gap-2 flex-wrap">
                {options.map((e, index) => {
                    if (index % 2 === 0) {
                        return (
                            <div key={"row_" + index} className="flex w-full space-x-2">
                                <Button
                                    key={"radio_" + index}
                                    style={checked === options[index].value ? `border  rounded-lg ${style1}` : `border  rounded-lg ${style2}`}
                                    name={options[index].label}
                                    onclick={() => changeType(options[index].value)}
                                />
                                {options[index+1] != null && (
                                    <Button
                                        key={"radio_" + (index + 1)}
                                        style={checked === options[index + 1].value ? `border  rounded-lg ${style1}` : `border  rounded-lg ${style2}`}
                                        name={options[index + 1].label}
                                        onclick={() => changeType(options[index + 1].value)}
                                    />
                                ) }
                            </div>
                        );
                    }
                    return null;
                })}
            </div>
        </>
    );
}

export default RadioCustom;